import { render, staticRenderFns } from "./MilkTypeDetails.vue?vue&type=template&id=7015edc2"
import script from "./MilkTypeDetails.vue?vue&type=script&lang=js"
export * from "./MilkTypeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports